<template>
  <div class="w-full video">
    <video
      ref="videoRef"
      :src="videoUrl"
      crossorigin="anonymous"
      preload="auto"
      class="block w-full h-[468px] rounded-[6px] bg-back-4"
      @loadeddata="onLoaded"
      @error="onError"
      @seeked="onSeeked"
    />
    <ImgList :list="frames" @change="onPointerChange" />
  </div>
</template>

<script lang="ts" setup>
import ImgList from './imgList.vue'

const props = defineProps<{ videoUrl: string }>()
const emit = defineEmits(['change', 'onload', 'error'])

const fileUrl = ref<string>('')
const videoRef = ref<HTMLVideoElement>()
const frames = ref<any[]>(new Array(14))
const canvas = document.createElement('canvas')
const { $t } = useNuxtApp()

const onPointerChange = (v: number) => {
  if (videoRef.value) {
    emit('change', '')
    videoRef.value.currentTime = v * videoRef.value?.duration
  }
}

const onLoaded = () => {
  emit('onload')
}
const onError = () => {
  message.error($t('shi-pin-jia-zai-shi-bai'))
  emit('error')
}
const onSeeked = () => {
  if (!videoRef.value) {
    return
  }

  const context = canvas.getContext('2d')
  context?.clearRect(0, 0, canvas.width, canvas.height)
  context?.drawImage(videoRef.value, 0, 0, canvas.width, canvas.height)
  fileUrl.value = canvas.toDataURL('image/png')
  emit('change', fileUrl.value)
}

const getFrams = () => {
  const video: any = document.createElement('video')
  video.setAttribute('crossorigin', 'anonymous')

  let step = 0
  let index = 0
  const context = canvas.getContext('2d')
  video.onloadeddata = () => {
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight
    step = video?.duration / 14
    video.currentTime = 0.1
  }
  video.onseeked = () => {
    context?.clearRect(0, 0, canvas.width, canvas.height)
    context?.drawImage(video, 0, 0, canvas.width, canvas.height)
    const img = canvas.toDataURL('image/jpeg')
    index === 0 ? frames.value.fill(img) : (frames.value[index] = img)
    if (video.currentTime < video?.duration - step) {
      video.currentTime += step
      index++
    }
  }
  video.src = props.videoUrl
  video.load()
}

getFrams()

defineExpose({
  fileUrl,
})
</script>

<style lang="scss" scoped></style>
